"use strict";

exports.__esModule = true;
exports.default = getBasePath;

/**
 * Retourne la base d’un chemin d’un URL.
 * Ajoute un "/" si la chaîne est vide.
 * @param {string} basePath
 * @return {string}
 */
function getBasePath(basePath) {
  return "" === basePath ? "/" : basePath;
}